import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { closingLines } from '../data/offer';
export function ClosingSection() {
  return <section className="rain-texture border-y border-primary/30 bg-surface/70 py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-38" data-mp="12su1nsplz4ev">
      <div className="mx-auto max-w-4xl px-4" data-id="element-39" data-mp="xthd93j39pa6">
        <h2 id="closing-title" className="text-balance text-center font-display text-4xl font-extrabold uppercase leading-[1.05] tracking-tight text-foreground sm:text-5xl" data-id="element-40" data-mp="xvv9vgtf39ju">
          Stop Reacting. <span className="text-accent" data-id="element-41" data-mp="17roiip40miwc">Start Preparing for El Niño.</span>
        </h2>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-42" data-mp="1litn85m8q1dj">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 rounded-xl border-l-4 border-highlight bg-background/90 px-4 py-3 text-sm font-semibold text-foreground" data-id="element-43" data-mp="1hi9pp0xr8vqv" data-mpi={index}>
              <ChevronRightIcon className="glow-led h-4 w-4 shrink-0 text-highlight" aria-hidden="true" data-id="element-44" data-mp="2ca0hamfaqf4t" />
              {line}
            </motion.li>)}
        </ul>
      </div>
    </section>;
}